import React from 'react';
import _, { includes } from 'lodash';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import {
  BannerContent,
  BannerImage,
  BannerPromo,
  PromoContainer,
} from './styles/BannerPromo.styled';
import { Button } from './styles/Button.styled';
import { Container } from './styles/Container.styled';
import { DWTCContext } from '../utils/context';

function OneColumnCTA({ data, id, dir }) {
  
  const { cssClass } = React.useContext(DWTCContext);

  const buttonTheme = () => {
    if (includes(cssClass, 'free-zone')) return 'red';
    if (includes(cssClass, 'real-estate')) return 'green';
    return 'secondary';
  };

  const handleStyle = (arr, index) => {
    if (arr.length > 1 && !index) return `${buttonTheme()}White`;
    if (includes(cssClass, 'regulations')) return `${buttonTheme()}White`;
    if (includes(cssClass, 'contact-us')) return `${buttonTheme()}White`;
    if (includes(cssClass, 'what-we-do')) return `${buttonTheme()}White`;
    return buttonTheme();
  };

  return (
    _.isEqual(cssClass, 'fullscreen') || (
      <BannerPromo id={id} className="promo-banner">
        <Container>
          <PromoContainer>
            <BannerImage>
              <LazyLoadImage
                width={1190}
                height="100%"
                placeholderSrc={
                  data.backgroundImage ? `${data.backgroundImage.url}?width=50&quality=50` : null
                }
                src={data.backgroundImage ? `${data.backgroundImage.url}` : ''}
                effect="blur"
              />
            </BannerImage>
            <BannerContent className="content" dir={dir}>
              <div className="caption">
                <h2 dir={dir}>{data.title}</h2>
                <p className="sub2">{data.description}</p>
              </div>
              <div className="banner-cta">
                {data.links.map(({ url, name, target }, index, arr) => (
                  <div key={index}>
                    <Button
                      to={url}
                      stylevariant={handleStyle(arr, index)}
                      target={target}
                      rel=""
                      dir={dir}
                      className="cta-btn">
                      {name}
                    </Button>
                  </div>
                ))}
              </div>
            </BannerContent>
          </PromoContainer>
        </Container>
      </BannerPromo>
    )
  );
}

export default OneColumnCTA;